import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedL1, setSelectedL2 } from '../redux/reducers/TagLevel';
import { setJobData } from 'src/redux/reducers/JobData';

export const useL1L2Params = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const l1 = searchParams.get('l1');
        const l2 = searchParams.get('l2');

        dispatch(setSelectedL1(l1));
        dispatch(setSelectedL2(l2));
    }, [location.search, dispatch]);

    return {
        l1: new URLSearchParams(location.search).get('l1'),
        l2: new URLSearchParams(location.search).get('l2'),
    };
};

export const useJobIdParam = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const jobId = searchParams.get('jobId');

        if (jobId) {
            dispatch(setJobData({
                job: {
                    id: jobId as any
                }
            }))
        }

    }, [location.search, dispatch]);

    return {
        jobId: new URLSearchParams(location.search).get('jobId'),
    };
}; 
